export enum AppType {
    AmberBills = 1,
    AmberCRM = 2,
    NextPageLabs = 3,
    AmberDegress = 5,
    RedstoneCMS = 6
}